import dayjs from 'dayjs';

import { StatType } from '@/api/pc-api/v1/{authInfoId}/service-stat/type';
import { ReportPeriod } from '@/pages/:AUTH_INFO_ID/stats/report/types/ReportPeriod';

export const getDefaultWeeklyDates = () => ({
  startDate: dayjs().startOf('week').subtract(1, 'week').add(1, 'day').format('YYYY-MM-DD'),
  endDate: dayjs().startOf('week').subtract(1, 'day').add(1, 'day').format('YYYY-MM-DD')
});

export const getDefaultMonthlyDates = () => ({
  startDate: dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
  endDate: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
});

export const getDefaultYearlyDates = () => ({
  startDate: dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
  endDate: dayjs().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
});

export const getTabUrl = (targetTab: ReportPeriod) => {
  const datesMap = {
    [ReportPeriod.WEEK]: getDefaultWeeklyDates,
    [ReportPeriod.MONTH]: getDefaultMonthlyDates,
    [ReportPeriod.YEAR]: getDefaultYearlyDates
  };
  const dates = datesMap[targetTab]();
  return `?tab=${targetTab}&startDate=${dates.startDate}&endDate=${dates.endDate}`;
};

export const getStatType = (tab: ReportPeriod) => {
  if (tab === ReportPeriod.WEEK) return StatType.WEEKLY;
  if (tab === ReportPeriod.YEAR) return StatType.YEARLY;
  return StatType.MONTHLY;
};
